module.exports = __webpack_public_path__ + "img/zhongbiao.aa5a9ce5.png";